import { render, staticRenderFns } from "./PlatformStats.vue?vue&type=template&id=195beb95&"
import script from "./PlatformStats.vue?vue&type=script&lang=js&"
export * from "./PlatformStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports